import { DescriptionSize } from 'aid-form-service';

export const HyperlinkSizes = {
  [DescriptionSize.SMALL]: 14,
  [DescriptionSize.MIDDLE]: 16,
  [DescriptionSize.BIGGER]: 22,
};
